import { useEffect, useState } from "react";
import "./Tour.css";
import InfoArea from '../ContentView/InfoArea';
import ImageCarousel from "../ContentView/ImageCarousel";
import ImageOverlay from "../ContentView/ImageOverlay";
import Overlay from "../common/Overlay";

// Component for displaying details of a tour

function TourModal({ tour, onStart, onClose }) {

    const [isOverlayOpen, setIsOverlayOpen] = useState(false);
    const [overlayImageIndex, setOverlayImageIndex] = useState(0);

    useEffect(() => {
        const originalStyle = window.getComputedStyle(document.body).overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.body.style.overflow = originalStyle;
        };
    }, []);

    if (!tour) return null;
    
    return (
        <div>
            <Overlay
                onClose={onClose}
                darkBackground={true}
                style={{
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)'
                }}
            >
                <div className="tour-detail-box">
                {/* Name of the tour */}
                    <h1 className="tour-detail-heading">{tour.name}</h1>

                    {/* Images */}
                    {tour.images?.length > 0 && (
                        <ImageCarousel 
                            images={tour.images} 
                            onImageClick={(index) => {
                                setOverlayImageIndex(index);
                                setIsOverlayOpen(true);
                            }}
                        />
                    )}

                    {/* Other information */}
                    {tour.location_infos && tour.location_infos
                        .slice()
                        .sort((a, b) => a.info_type.order - b.info_type.order)
                        .map((info) => (
                        <InfoArea
                            key={info.id}
                            title={info.info_type.title}
                            value={info.content}
                            icon={info.info_type.icon}
                        />
                    ))}
                    <div>
                        <button
                            className="TextButton"
                            onClick={() => {
                                onStart(tour);
                                onClose();
                            }}
                        >
                            Tour starten
                        </button>
                        <button
                            className="TextButton"
                            onClick={onClose}
                        >
                            Abbrechen
                        </button>
                    </div>
                </div>
            </Overlay>
            {/* Clicking an image will display it in an overlay */}
                {isOverlayOpen && tour.images?.length > 0 && (
                    <ImageOverlay
                        overlayImageIndex={overlayImageIndex}
                        setOverlayImageIndex={setOverlayImageIndex}
                        content={tour}
                        setIsOverlayOpen={setIsOverlayOpen}
                    />
                )}
        </div>
    );
}

export default TourModal;